<template>
  <div class="invite-page">
    <van-popup
      v-model="displaySelectStudent"
      style="overflow: unset; overflow-y: auto; background: none;"
    >
      <select-student
        :studentList="studentList"
        @close="displaySelectStudent = false"
        @confirm="recordStudentActivation"
      ></select-student>
    </van-popup>
    <div class="invite-header" v-if="!userinfo.mobile">
      <div class="invitees-reg-form">
        <div class="invitees-title">
          <div class="invitees-title-icon"></div>
          请选择宝贝年级
          <div class="invitees-title-desc">（其他年级敬请期待…）</div>
        </div>
        <div class="select-grade">
          <div
            :class="['grade3', selectgrade === 3 ? 'grade-select-act' : '']"
            @click="selectgrade = 3"
          ></div>
          <div
            :class="['grade4', selectgrade === 4 ? 'grade-select-act' : '']"
            @click="selectgrade = 4"
          ></div>
          <div
            :class="['grade5', selectgrade === 5 ? 'grade-select-act' : '']"
            @click="selectgrade = 5"
          ></div>
        </div>
        <div class="invitees-title">
          <div class="invitees-title-icon"></div>
          申请领取新生礼包
        </div>
        <div class="invitees-phone-c top-space">
          <!-- <div class="invitees-phone-icon"></div> -->
          <input
            class="invitees-phone"
            placeholder="请输入手机号"
            v-model="inputphone"
          />
        </div>
        <div class="invitees-phone-err">{{ errormsg }}</div>
        <div class="invitees-phone-c">
          <!-- <div class="invitees-code-icon"></div> -->
          <input
            class="invitees-code"
            placeholder="请输入验证码"
            v-model="inputcode"
          />
          <div v-if="timeout > 0" class="invitees-codetime">
            已发送({{ timeout }}s)
          </div>
          <div v-else @click="sendSmsCode" class="invitees-codetime">
            {{ sendcode ? '重新发送' : '发送验证码' }}
          </div>
        </div>
        <div class="invitees-phone-err">{{ codeerrormsg }}</div>
        <div class="invitees-item">不要忘记选择宝贝年级哦！</div>
        <div @click="subCommit" class="invitees-button-c"></div>
      </div>
    </div>
    <div v-else class="invite-header-log">
      <div class="invite-log-form">
        <div class="invitees-title">
          <div class="invitees-title-icon"></div>
          申请领取新生礼包
        </div>
        <div class="invitees-phone-c top-space">
          <!-- <div class="invitees-phone-icon"></div> -->
          <input
            class="invitees-phone"
            placeholder="请输入手机号"
            v-model="inputphone"
            disabled="disable"
          />
        </div>
        <div class="invitees-phone-err"></div>
        <div @click="subCommit" class="invitees-button-c"></div>
      </div>
    </div>
    <div class="invite-whyvip"></div>
    <div class="why-v" ref="videobox">
      <div class="touch-video" @click="switchStatus">
        <video
          ref="video"
          :style="`visibility:${isplay ? 'visible' : 'hidden'}`"
          src="https://img.vipkidstatic.com/ec-edu/math/customer/referral/%E6%95%B0%E5%AD%A6%E6%80%9D%E7%BB%B4-%E8%AF%BE%E4%B8%AD%E4%BA%AE%E7%82%B9%E9%9B%86%E9%94%A6%E8%A7%86%E9%A2%91.mp4"
          :poster="poster"
          line
          playsinline
          x5-playsinline
          x-webkit-airplay="true"
          webkit-playsinline="true"
          x5-video-player-type="h5"
          x5-video-player-fullscreen=""
          x5-video-orientation="portraint"
          @pause="videoPause"
          @play="videoPlay"
        >
          your browser does not support the video tag
        </video>
        <img v-show="!isplay" :src="poster" />
        <div v-show="!isplay" class="touch-bt"></div>
      </div>
    </div>
    <div class="invite-highlights"></div>
    <div class="invite-frontline">
      <div class="invite-teachers">
        <van-swipe
          ref="swipe"
          class="invite-teachers-swipe"
          :loop="true"
          indicator-color="#E36030"
          :show-indicators="false"
        >
          <van-swipe-item>
            <div class="teacher-bigfu"></div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="teacher-bigwhite"></div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="double-guarantee"></div>
    <div class="invite-footer" v-if="!userinfo.mobile">
      <div class="invitees-reg-form reg-footer">
        <div class="invitees-title">
          <div class="invitees-title-icon"></div>
          请选择宝贝年级
          <div class="invitees-title-desc">（其他年级尽请期待…）</div>
        </div>
        <div class="select-grade">
          <div
            :class="['grade3', selectgrade === 3 ? 'grade-select-act' : '']"
            @click="selectgrade = 3"
          ></div>
          <div
            :class="['grade4', selectgrade === 4 ? 'grade-select-act' : '']"
            @click="selectgrade = 4"
          ></div>
          <div
            :class="['grade5', selectgrade === 5 ? 'grade-select-act' : '']"
            @click="selectgrade = 5"
          ></div>
        </div>
        <div class="invitees-title">
          <div class="invitees-title-icon"></div>
          申请领取新生礼包
        </div>
        <div class="invitees-phone-c top-space">
          <!-- <div class="invitees-phone-icon"></div> -->
          <input
            class="invitees-phone"
            placeholder="请输入手机号"
            v-model="inputphone"
          />
        </div>
        <div class="invitees-phone-err">{{ errormsg }}</div>
        <div class="invitees-phone-c">
          <!-- <div class="invitees-code-icon"></div> -->
          <input
            class="invitees-code"
            placeholder="请输入验证码"
            v-model="inputcode"
          />
          <div v-if="timeout > 0" class="invitees-codetime">
            已发送({{ timeout }}s)
          </div>
          <div v-else @click="sendSmsCode" class="invitees-codetime">
            {{ sendcode ? '重新发送' : '发送验证码' }}
          </div>
        </div>
        <div class="invitees-phone-err">{{ codeerrormsg }}</div>
        <div class="invitees-item">不要忘记选择宝贝年级哦！</div>
        <div @click="subCommit" class="invitees-button-c"></div>
      </div>
    </div>
    <div class="invite-footer-log" v-else>
      <div class="invite-log-form footer-log-form">
        <div class="invitees-title">
          <div class="invitees-title-icon"></div>
          申请领取新生礼包
        </div>
        <div class="invitees-phone-c top-space">
          <!-- <div class="invitees-phone-icon"></div> -->
          <input
            class="invitees-phone"
            placeholder="请输入手机号"
            v-model="inputphone"
            disabled="disable"
          />
        </div>
        <div class="invitees-phone-err"></div>
        <div @click="subCommit" class="invitees-button-c"></div>
      </div>
    </div>
  </div>
</template>
<script>
// import jssdk, { wx } from '@/mixins/jssdk'
import cookie from 'js-cookie'
import gateway from '@/_gateway.config'
import { sendSmsCode, loginByCode, drainageSignUp } from '@/api/common'
import {
  getReferrer,
  recordActivation,
  recordStudentActivation
} from '@/api/landingpage'
import {
  updateStudentInfo,
  getStudentList,
  getStudentInfo
} from '@/api/account'
import poster from '@/assets/img/actouch/poster.png'
import '@/utils/gt'
import sasdk from './sasdkinit'
import { isPhone } from '@/utils/vilidate'
import { Toast } from 'vant'

import SelectStudent from './select-student.vue'

// 多业务登录注册
// const appId = process.env.VUE_APP_ENV === 'production' ? 'gh_1343a1dcee8e' : '10034'
var timemeter
var appId
var channelKeyword
var channelId
var activityCode
var winh = document.documentElement.getBoundingClientRect().height
var winw = document.documentElement.getBoundingClientRect().width
var videotop = 0
var videoheight = 0
var initw = winw / 750
var hasplay = false
export default {
  components: {
    SelectStudent
  },
  data () {
    return {
      // 邀请人信息
      // inviter: {},
      // 被邀请人信息
      userinfo: {},
      // 手机号输入框值
      inputphone: '',
      // 验证码输入框值
      inputcode: '',
      // 显示错误信息
      errormsg: '',
      // 显示错误信息
      codeerrormsg: '',
      // 显示计时
      timeout: 0,
      // 是否发送验证码
      sendcode: false,
      // 开放年级选择
      selectgrade: 3,
      isplay: false,
      poster,
      // 枚举数字图片名称
      // nums: ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']
      // 是否显示选择学生弹窗
      displaySelectStudent: false,
      studentList: []
    }
  },
  // mixins: [jssdk],
  async created () {
    appId = this.$route.query.appId || ''
    channelKeyword = this.$route.query.channelKeyword || ''
    channelId = this.$route.query.channelId || ''
    activityCode = this.$route.query.activityCode || ''
    const parentId = this.getParentID()
    const Authorization = cookie.get('Authorization')
    sasdk.registerPage({
      channel_id: channelId
    })
    if (parentId && Authorization) {
      this.drainageSignUp()
      getReferrer({
        parentId: parentId
      }).then(res => {
        if (res.code === 200) {
          this.userinfo = res.data
          this.inputphone = res.data.mobile
        }
      })
      // 神策埋点 userid
      // cookie.set('cookie_id', parentId)
    }
    // if (this.$route.query.channelKeyword) {
    //   getReferrer({
    //     parentId: this.$route.query.channelKeyword
    //   }).then(res => {
    //     if (res.code === 200) {
    //       this.inviter = res.data
    //     }
    //   })
    // }
  },
  mounted () {
    sasdk.viewindex()
    window.addEventListener('scroll', this.onPageScroll)
    videotop = this.$refs.videobox.offsetTop
    videoheight = this.$refs.videobox.clientHeight
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onPageScroll)
  },
  methods: {
    // onjssdkready () {
    //   wx.hideMenuItems({
    //     menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:QZone'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
    //   })
    // },
    getParentID () {
      return cookie.get('mathparentid') || cookie.get('mbparentid') || null
    },
    getReferrer (callback) {
      const parentId = this.getParentID()
      getReferrer({
        parentId: parentId
      })
        .then(res => {
          if (res.code === 200) {
            this.userinfo = res.data
            this.inputphone = res.data.mobile
          }
          if (typeof callback === 'function') {
            callback()
          }
        })
        .catch(() => {
          if (typeof callback === 'function') {
            callback()
          }
        })
    },
    sendSmsCode () {
      // sasdk.getfreecode()
      this.errormsg = ''
      this.codeerrormsg = ''
      if (!isPhone(this.inputphone)) {
        this.errormsg = '*请输入正确的手机号码'
        return
      }
      if (this.sendingsmscode) {
        this.codeerrormsg = '*请输入手机验证码'
        return
      }
      this.sendingsmscode = true
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      sendSmsCode(
        {
          username: this.inputphone,
          type: 1,
          appId,
          function: 'login',
          channelId,
          channelKeyword
        },
        this.headers
      )
        .then(res => {
          this.sendingsmscode = false
          Toast.clear()
          if (res.data.code === 0) {
            this.sendcode = true
            this.codeTimeout()
          } else {
            this.codeerrormsg = res.data.msg
          }
        })
        .catch(err => {
          Toast.clear()
          this.sendingsmscode = false
          if (err && err.response && err.response.status === 410) {
            if (this.captchaObj) {
              this.captchaObj.verify()
            } else {
              // 初始化极验组件
              var headers = err.response.headers
              var gtinfo = (this.gtinfo = {
                gt: headers['vk-gt'],
                challenge: headers['vk-gt-challenge'],
                initsuccess: headers['vk-gt-initsuccess'],
                newcaptcha: headers['vk-gt-newcaptcha']
              })
              // eslint-disable-next-line no-undef
              initGeetest(
                {
                  // 以下 4 个配置参数为必须，不能缺少
                  gt: gtinfo.gt,
                  challenge: gtinfo.challenge,
                  offline: gtinfo.initsuccess === 'false', // 表示用户后台检测极验服务器是否宕机
                  new_captcha: gtinfo.newcaptcha === 'true', // 用于宕机时表示是新验证码的宕机

                  product: 'bind', // 产品形式，包括：float，popup
                  width: '300px'

                  // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
                },
                captchaObj => {
                  this.captchaObj = captchaObj
                  captchaObj
                    .onReady(() => {
                      captchaObj.verify()
                    })
                    .onSuccess(() => {
                      const result = captchaObj.getValidate()
                      this.headers = {
                        'vk-gt-challenge': result.geetest_challenge,
                        'vk-gt-validate': result.geetest_validate,
                        'vk-gt-seccode': result.geetest_seccode,
                        'vk-gt-type': 2
                      }
                      this.sendSmsCode()
                    })
                  //
                }
              )
            }
          } else if (err && err.response && err.response.status === 400) {
            if (err.response.data && err.response.data.msg) {
              switch (err.response.data.msg) {
                case 'VERIFY_CODE_SEC_REPEAT':
                  this.codeerrormsg = '操作太过频繁，请稍后重试！'
                  break
                case 'PARAMETER_ERROR':
                  this.codeerrormsg = '请输入正确的手机号码！'
                  break
                case 'VERIFY_CODE_SEND_ERROR':
                  this.codeerrormsg = '验证码发送失败，请重试！'
                  break
                case 'MOBILE_INVALID':
                  this.codeerrormsg = '请输入正确的手机号码！'
                  break
                default:
                  this.codeerrormsg = '验证码发送失败，请重试！'
                  break
              }
            }
          }
        })
    },
    codeTimeout () {
      this.timeout = 60
      var current = new Date().getTime()
      clearInterval(timemeter)
      timemeter = setInterval(() => {
        var now = new Date().getTime()
        var timeout = 60 - Math.floor((now - current) / 1000)
        if (timeout < 0) {
          clearInterval(timemeter)
        } else {
          this.timeout = timeout
        }
      }, 1000)
    },
    // 点击立即领取
    subCommit () {
      this.errormsg = ''
      this.codeerrormsg = ''
      sasdk.getfree()
      // 如果没有默认登录，就去登录
      if (!this.userinfo.mobile) {
        if (!isPhone(this.inputphone)) {
          this.errormsg = '*请输入正确的手机号码'
          return
        }
        if (!this.inputcode) {
          this.codeerrormsg = '*请输入正确的验证码'
          return
        }
        this.login()
        // 如果登录了，直接同步引流信息
      } else {
        // this.drainageSignUp()
        // this.recordActivation()
        this.doSelectStudent()
      }
    },
    login () {
      // if (!(/^1[34578]\d{9}$/.test(this.inputphone))) {
      //   this.errormsg = '请输入正确的手机号'
      //   return false
      // }
      if (!this.inputcode) {
        this.codeerrormsg = '请输入短信验证码'
        return false
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      loginByCode({
        username: this.inputphone,
        verifyCode: this.inputcode,
        channelKeyword,
        channelId,
        appId
      })
        .then(res => {
          if (res.status === 200 && res.data.code === 0) {
            cookie.set('Authorization', res.data.data.token)
            this.drainageSignUp()
              .then(res => {
                // this.recordActivation()
                this.userinfo.mobile = this.inputphone
                this.doSelectStudent()
                Toast.clear()
              })
              .catch(() => {
                Toast.clear()
              })
          } else {
            this.errormsg = res.data.msg
            Toast.clear()
          }
        })
        .catch(err => {
          Toast.clear()
          if (err && err.response && err.response.status === 400) {
            if (err.response.data && err.response.data.msg) {
              switch (err.response.data.msg) {
                case 'VERIFY_CODE_SEC_REPEAT':
                  this.codeerrormsg = '操作太过频繁，请稍后重试！'
                  break
                case 'PARAMETER_ERROR':
                  this.codeerrormsg = '手机号或验证码错误'
                  break
                case 'VERIFY_CODE_ERROR':
                  this.codeerrormsg = '验证码错误'
                  break
                case 'VERIFY_CODE_EXPIRED':
                  this.codeerrormsg = '验证码过期'
                  break
                default:
                  this.codeerrormsg = '登录异样'
                  break
              }
            }
          }
        })
    },
    // uc 记录引流关系
    drainageSignUp () {
      return new Promise(function (resolve, reject) {
        drainageSignUp({
          appId,
          channelId,
          channelKeyword,
          birthday: new Date()
        })
          .then(res => {
            if (res.code === 0) {
              if (res.data.id) {
                cookie.set('mathparentid', res.data.id)
                cookie.set('cookie_id', res.data.id)
                sasdk.registerPage({
                  student_id: '',
                  parent_id: res.data.id
                })
              }
              resolve()
            } else {
              reject(res.message)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    recordActivation () {
      var parentId = this.getParentID()
      var checkresult = function () {
        if (this.userinfo.hadMathOrder) {
          this.$router.push('/landingpage/fail')
        } else {
          this.$router.push('/landingpage/success')
        }
      }
      // if (parentId === channelKeyword) {
      //   this.codeerrormsg = '自己不能邀请自己哦！'
      //   return
      // }
      recordActivation({
        activityCode,
        channelId,
        parentId,
        grade: this.selectgrade
      })
        .then(res => {
          // checkresult.call(this)
        })
        .catch(() => {
          // checkresult.call(this)
        })
      this.getReferrer(() => {
        checkresult.call(this)
      })
    },
    recordStudentActivation (studentId) {
      const parentId = this.getParentID()
      cookie.set('mbstudentid', studentId, {
        domain: gateway.domain
      })
      sasdk.registerPage({
        student_id: studentId
      })
      sasdk.receive()
      // 激活与更新信息已拆成 2 个接口
      recordStudentActivation({
        activityCode,
        channelId,
        channelKeyword,
        parentId,
        studentId,
        grade: this.selectgrade
      }).finally(() => {
        updateStudentInfo({
          studentId,
          grade: this.selectgrade
        }).finally(() => {
          getStudentInfo({ studentId })
            .then(response => {
              let data = response.data
              if (response.code !== 200) {
                Toast('领取失败，请联系客服。')
                return
              }
              if (data.hadMathOrder || data.hadTrialOrder) {
                this.$router.push('/landingpage/fail')
              } else {
                location.href = {
                  3: '//mobile.vipkid.com.cn/shop/spread/sp_6e1d149d',
                  4: '//mobile.vipkid.com.cn/shop/spread/sp_a3be8a5a',
                  5: '//mobile.vipkid.com.cn/shop/spread/sp_83767436'
                }[this.selectgrade]
                // this.$router.push('/landingpage/success')
                // 需求要求直接跳转到购课页
                // http://wiki.vipkid.com.cn/pages/viewpage.action?pageId=213986604
              }
            })
            .catch(e => {
              console.log(e)
              // Toast('网络错误，领取失败，请重试。')
            })
        })
      })
    },
    doSelectStudent () {
      Toast.loading()

      getStudentList({ parentId: this.getParentID() }).then(response => {
        Toast.clear()
        let data = response.data
        this.studentList = data.map(student => {
          return {
            id: student.id,
            avatar: student.avatarUrl,
            name: student.name
          }
        })

        if (this.studentList.length > 1) {
          this.displaySelectStudent = true
        } else {
          this.recordStudentActivation(this.studentList[0].id)
        }
      })
    },
    swipepre () {
      this.$refs.swipe.prev()
    },
    swipenext () {
      this.$refs.swipe.next()
    },
    onPageScroll () {
      var top = document.scrollingElement.scrollTop
      this.showbottom = top > winh
      if (this.isplay) {
        if (
          top > videotop - winh + videoheight - 240 * initw &&
          top < videotop + videoheight - 350
        ) {
          // if (this.fixvideo) {
          //   this.fixvideo = false
          //   this.$refs.videobox.appendChild(this.$refs.video)
          //   console.log('movein')
          // }
        } else {
          // if (!this.fixvideo) {
          //   this.fixvideo = true
          //   this.$refs.videofixed.appendChild(this.$refs.video)
          //   console.log('moveout')
          // }
          this.isplay = false
          setTimeout(() => {
            this.$refs.video.pause()
          })
        }
      }
    },
    videoPause () {
      if (this.isplay) {
        this.isplay = false
      }
    },
    videoPlay () {
      this.isplay = true
      if (!hasplay) {
        hasplay = true
      }
    },
    switchStatus () {
      if (this.isplay) {
        this.$refs.video.pause()
      } else {
        this.$refs.video.play()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/img/landingpage/spriteout/sprites.scss';
#app {
  background-color: #2a41b9;
  font-family: sans-serif !important;
}
.invite-page {
  min-height: 100vh;
  width: 750px;
  margin: 0 auto;
}
.invite-header {
  // @include sprite(bgimg);
  background: url(~@/assets/img/landingpage/invite-header.png) no-repeat;
  background-size: cover;
  width: 750px;
  height: 2388px;
  position: relative;
}
.invite-header-log {
  background: url(~@/assets/img/landingpage/invite-header-log.png) no-repeat;
  background-size: cover;
  width: 750px;
  height: 1916px;
  position: relative;
}
.invite-log-form {
  position: absolute;
  top: 1450px;
  left: 0px;
  width: 100%;
  &.footer-log-form {
    top: 800px;
  }
}
.invitees-reg-form {
  position: absolute;
  top: 1450px;
  left: 0px;
  width: 100%;
  &.reg-footer {
    top: 800px;
  }
}
.invitees-title {
  display: flex;
  align-items: center;
  font-weight: bold;
  color: black;
  font-size: 30px;
  margin-left: 70px;
  .invitees-title-desc {
    font-weight: normal;
    font-size: 24px;
    color: #364a56;
  }
}
.invitees-title-icon {
  @include sprite(icon);
}
.select-grade {
  // display:flex;
  margin: 15px 45px 25px;
  // justify-content: space-around;
  .grade3 {
    display: inline-block;
    margin: 0px 16px;
    @include sprite(grade3);
    &.grade-select-act {
      @include sprite(grade3-selected);
    }
  }
  .grade4 {
    display: inline-block;
    margin: 16px;
    @include sprite(grade4);
    &.grade-select-act {
      @include sprite(grade4-selected);
    }
  }
  .grade5 {
    display: inline-block;
    margin: 16px;
    @include sprite(grade5);
    &.grade-select-act {
      @include sprite(grade5-selected);
    }
  }
}
.invitees-phone-c {
  width: 580px;
  height: 80px;
  margin: auto;
  border-radius: 10px;
  color: #949ba0;
  background: #f5fbff;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.top-space {
  margin-top: 30px;
}
.invitees-phone-disabled {
  background: #ddd;
}
.invitees-phone-icon {
  @include sprite(shouji);
  margin-left: 20px;
}
.invitees-code-icon {
  @include sprite(code);
  margin-left: 20px;
}
.invitees-phone {
  margin-left: 30px;
  margin-right: 10px;
  height: 80px;
  line-height: 80px;
  font-size: 27px;
  flex: 1;
  color: #404040;
  display: block;
  background: transparent;
}
.invitees-code {
  margin-left: 30px;
  margin-right: 10px;
  height: 80px;
  line-height: 80px;
  font-size: 27px;
  flex: 1;
  width: 200px;
  color: #404040;
  display: block;
  background: transparent;
}
.invitees-codetime {
  width: 181px;
  height: 80px;
  line-height: 80px;
  background: #059bf5;
  color: white;
  font-size: 24px;
  text-align: center;
  font-weight: 400;
}
.invitees-phone-err {
  color: #059bf5;
  font-size: 16px;
  width: 440px;
  height: 40px;
  line-height: 40px;
  margin-left: 100px;
}
.invitees-item {
  width: 280px;
  margin: 10px auto 0;
  text-align: center;
  line-height: 50px;
  font-size: 24px;
  color: #364a56;
  border-bottom: 1px solid #364a56;
  white-space: nowrap;
}
.invitees-button-c {
  @include sprite(button);
  margin: 20px auto 0;
  border-radius: 50px;
  box-shadow: 0px 30px 50px #9bdefb;
}
.num-icon {
  display: inline-block;
  margin: 0 2px;
}
.invite-whyvip {
  background: url(~@/assets/img/landingpage/whyvip.png) no-repeat;
  background-size: cover;
  width: 750px;
  height: 1062px;
  position: relative;
}
.why-v {
  background: url(~@/assets/img/landingpage/why-v.png) no-repeat;
  background-size: cover;
  width: 750px;
  height: 979px;
  position: relative;
  overflow: hidden;
}
.touch-video {
  margin: 350px auto 0;
  width: 640px;
  height: 370px;
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  video,
  img {
    width: 640px;
    height: 370px;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
  }
  .touch-bt {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @include sprite(play);
  }
}
.invite-highlights {
  background: url(~@/assets/img/landingpage/highlights.png) no-repeat;
  background-size: cover;
  width: 750px;
  height: 1477px;
  position: relative;
}
.invite-teachers {
  position: absolute;
  top: 100px;
  left: 0px;
  width: 750px;
}
.invite-teachers-swipe {
  width: 750px;
  height: 600px;
  margin: 0 auto;
}
.teacher-bigwhite {
  @include sprite(bigwhite);
}
.teacher-bigfu {
  @include sprite(bigfu);
}
.invite-frontline {
  background: url(~@/assets/img/landingpage/frontline.png) no-repeat;
  background-size: cover;
  width: 750px;
  height: 709px;
  position: relative;
  overflow: hidden;
}
.double-guarantee {
  background: url(~@/assets/img/landingpage/double-guarantee.png) no-repeat;
  background-size: cover;
  width: 750px;
  height: 681px;
  position: relative;
  overflow: hidden;
}
.invite-footer {
  background: url(~@/assets/img/landingpage/footer.png) no-repeat;
  background-size: cover;
  width: 750px;
  height: 1697px;
  position: relative;
}
.invite-footer-log {
  background: url(~@/assets/img/landingpage/footer-log.png) no-repeat;
  background-size: cover;
  width: 750px;
  height: 1324px;
  position: relative;
}
</style>
